import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CitiesProvider } from "@/context/CitiesContext";
import { CategoriesProvider } from "@/context/CategoriesContext";
import { DEFAULT_CITY } from "@/constants/cities";
import Home from "@/pages/Home";
import EventDetail from "@/pages/EventDetail";
import Submit from "@/pages/Submit";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import OrganiserPortal from "@/pages/OrganiserPortal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CitiesProvider>
          <CategoriesProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to={`/${DEFAULT_CITY}`} replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/portal" element={<OrganiserPortal />} />
                <Route path="/:city" element={<Home />} />
                <Route path="/:city/event/:id" element={<EventDetail />} />
                <Route path="/:city/submit" element={<Submit />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
          </CategoriesProvider>
        </CitiesProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
